<template>
    <div class="row justify-content-center">
        <div class="col-md-7 col-11">
            <card class="mt-3">
                <el-form label-width="220px" :label-position="$store.state.props.isMobile ? 'top' : 'right'">
                    <el-form-item label="Name">
                        <el-input v-model="currentUser.name" />
                    </el-form-item>
                    <el-form-item label="Email">
                        <el-input v-model="currentUser.email" />
                    </el-form-item>
                    <el-form-item v-if="!currentUser.admin" label="Active">
                        <el-checkbox v-model="currentUser.status"/>
                    </el-form-item>
                    <!-- <el-form-item label="Make Super Admin">
                        <el-checkbox :value="currentUser.admin" @change="makeSuperAdmin" />
                        <button v-if="!prevAdmin && currentUser.admin" @click.prevent="revertSuperAdmin" class="revert-button">Undo</button>
                    </el-form-item>
                    <el-form-item label="Verified">
                        <el-checkbox v-model="currentUser.verified"/>
                    </el-form-item> -->
                    <el-form-item label="Enable 2 Factor Authentication">
                        <el-checkbox v-model="currentUser.twoFaEnabled"/>
                    </el-form-item>
                </el-form>

                <template slot="footer">
                    <div class="d-flex justify-content-end">
                        <el-button class="btn btn-primary" :loading="saving" @click="submit()">
                            Save
                        </el-button>
                    </div>
                </template>
            </card>
        </div>
    </div>
</template>

<script>

import swal from 'sweetalert2'
import { mapState } from 'vuex'
import http from '../../http.js'

export default {
    data() {
        return {
            loading: false,
            currentUser: null,
            prevAdmin: false,
            saving: false
        }
    },
    computed: {
        ...mapState([
            'user',
            'event'
        ])
    },
    mounted() {
        this.getUsers()
    },
    methods: {
        revertSuperAdmin(){
            this.currentUser.admin = false;
        },
        async makeSuperAdmin(value) {
            if(!value) return;
            if(this.prevAdmin && value ) return;
            let { value: confirmed } = await swal({
                title: `Are you sure you want to make this user a superadmin ? Only one superadmin is allowed`,
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-default btn-fill'
            })
            if(confirmed){
                this.currentUser.admin = value
            }
            else{
                this.currentUser.admin = false
            }
        },
        getUsers: async function () {
            this.loading = true
            try {
                const userRes = await http.get(`/api/users/${this.$route.params.userId}`)

                this.currentUser = userRes.data.user;
                this.prevAdmin = this.currentUser.admin;

                console.log(this.currentUser);


            } catch (e) {
                console.log('erorr getting users')
            }
            this.loading = false
        },
        remove: async function (id) {
            try {
                let { value: confirmed } = await swal({
                    title: `Are you sure you want to delete this user?`,
                    buttonsStyling: false,
                    showCancelButton: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-default btn-fill'
                })

                if (confirmed) {
                    this.$store.commit('SET', ['users', this.$store.state.users.filter(user => user._id !== id)])
                    this.$store.dispatch('remove', { path: 'users', id })
                }
            } catch (e) {
                console.log(e)
                console.log('error deleting user')
            }
        },
        statusChsage: async function (id) {
            try {
                const usr = await http.put(`/api/user-status/${id}`)
                //console.log('@@usr', usr)
                // let { value: confirmed } = await swal({
                //     title: `Are you sure you want to delete this user?`,
                //     buttonsStyling: false,
                //     showCancelButton: true,
                //     confirmButtonText: 'OK',
                //     cancelButtonText: 'Cancel',
                //     confirmButtonClass: 'btn btn-success btn-fill',
                //     cancelButtonClass: 'btn btn-default btn-fill'
                // })

                // if (confirmed) {
                //     this.$store.commit('SET', ['users', this.$store.state.users.filter(user => user._id !== id)])
                //     this.$store.dispatch('remove', { path: 'users', id })
                // }
            } catch (e) {
                console.log(e)
                console.log('error deleting user')
            }
        },

        async submit(){
            this.saving = true
            const { data } = await http.put(`/api/users/${this.currentUser._id}`, this.currentUser);
            this.$notify('Information successfully updated!');
            console.log(data);
            this.saving = false
            
        }
    }
}


</script>

<style scoped>
.revert-button{
    border: none;
    background: transparent;
    margin-left: 10px;

}

.revert-button:hover{
    text-decoration: underline;
}
</style>